<div class="info-container">
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.TOTAL_BUGGY_LENGTH' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ getTotalBuggyLengthLabel() }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.CURRENT_LENGTH_IN_BUGGY' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ getCurrentLengthInBuggyLabel() }}</div>
  </div>
</div>
